import { Box } from '@mantine/core';

import type { IconPropsType } from './types';

export const EmptyDocumentsIcon = ({
  size = 120,
  sx,
  ...props
}: IconPropsType) => (
  <Box
    component="svg"
    sx={sx}
    width={size}
    height={size}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="120" height="120" rx="60" fill="#EFF1F5" />
    <path
      d="M33.5693 70.0474L53.1709 69.3176L53.1642 69.1175L33.5626 69.8473L33.5693 70.0474ZM33.2028 60.4606L52.8036 59.7094L52.796 59.5103L33.1952 60.2616L33.2028 60.4606ZM32.8344 50.874L45.9793 50.378L45.9727 50.1789L32.8277 50.6739L32.8344 50.874ZM66.2188 78.3245C66.3525 81.8146 63.6075 84.7288 60.1191 84.8627L27.8342 86.1001C24.3457 86.2336 21.3857 83.5381 21.2518 80.048L19.7811 41.6758C19.6475 38.1857 22.3924 35.2715 25.8809 35.1375L52.9938 34.0984L53.4486 34.5158L64.483 44.6377L64.9439 45.0608L66.2188 78.3245Z"
      fill="white"
      stroke="#475B70"
      strokeWidth="3"
    />
    <path
      d="M65.2086 67.131L84.2805 71.7158L84.328 71.5214L65.2561 66.9366L65.2086 67.131ZM67.4417 57.8008L86.5186 62.3647L86.565 62.171L67.4881 57.6071L67.4417 57.8008ZM69.673 48.4701L82.4644 51.5384L82.5117 51.3448L69.7205 48.2757L69.673 48.4701ZM94.4151 83.9085C93.6024 87.3053 90.1731 89.371 86.7778 88.5589L55.3559 81.0417C51.9607 80.2292 49.8376 76.8351 50.6501 73.4383L59.5848 36.0918C60.3975 32.695 63.8268 30.6293 67.2221 31.4413L93.6103 37.7543L93.9356 38.279L101.831 51.0022L102.16 51.534L94.4151 83.9085Z"
      fill="white"
      stroke="#475B70"
      strokeWidth="3"
    />
  </Box>
);
